import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import defaultDates from '../../../utils/defaultDates';
import LiveReportRenderContext from '../../../StateManagment/LiveReportRenderContext';
import useHierarchyData from '../../../hooks/useHierarchyData';
import toMillis from '../../../helpers/dataHelpers/matrixDataHelpers/toMillis';
import ArrowLeftIcon from '../../../images/icons/arrow-left-icon.png';
import ArrowRightIcon from '../../../images/icons/arrow-right-icon.png';
import EventFieldInfoPopover from './EventFieldInfoPopover';
import AnalyticsEmptyState from '../../dashboard/AnalyticsEmptyState';

// AI-CONTEXT: See docs/features/api-data-fetching.md

const EventOpenData = ({ field, startDate, endDate, activityId }) => {
  const inLiveReport = useContext(LiveReportRenderContext);
  const [current, setCurrent] = useState(0);
  const lastFieldIdRef = useRef(field?.ID);

  const { defaultStartDate: dsRaw, defaultEndDate: deRaw } = useMemo(() => defaultDates(), []);
  const dsMs = useMemo(() => toMillis(dsRaw) ?? 0, [dsRaw]);
  const deMs = useMemo(() => toMillis(deRaw) ?? 8640000000000000, [deRaw]);
  const startMs = useMemo(() => toMillis(startDate) ?? dsMs, [startDate, dsMs]);
  const endMs = useMemo(() => toMillis(endDate) ?? deMs, [endDate, deMs]);

  const { records, hierarchy: projectHierarchy, loading } = useHierarchyData({
    syncType: 'Event',
    id: field?.ID,
    startDate: startMs,
    endDate: endMs,
  });

  // Reset cursor when switching to a different field
  useEffect(() => {
    if (lastFieldIdRef.current !== field?.ID) {
      setCurrent(0);
      lastFieldIdRef.current = field?.ID;
    }
  }, [field?.ID]);

  // Clamp cursor when data size changes
  useEffect(() => {
    setCurrent(i => {
      if (records.length === 0) return 0;
      return i % records.length;
    });
  }, [records.length]);

  const handleNext = () => {
    if (records.length === 0) return;
    setCurrent(i => (i + 1) % records.length);
  };

  const handlePrev = () => {
    if (records.length === 0) return;
    setCurrent(i => (i - 1 + records.length) % records.length);
  };

  if (loading) return null;

  return (
    <>
      {!inLiveReport && (
        <div className='home-kpi-question-title-container'>
          {field?.Title && <p className='event-field-title'>{field.Title}</p>}
          <EventFieldInfoPopover field={field} activityId={activityId} totalResponses={records.length} projectHierarchy={projectHierarchy} />
        </div>
      )}

      {records.length === 0 ? (
        <AnalyticsEmptyState />
      ) : (
        <>
          <div id="live-report-open-question-slider">
            <p id="open-question-response-p-tag">
              {records[current]?.Value ?? 'Geen data'}
            </p>
          </div>

          <div id="live-report-effect-indicator-navbar">
            <img src={ArrowLeftIcon} alt="Vorige" onClick={handlePrev} />
            <span>{`${current + 1} van de ${records.length}`}</span>
            <img src={ArrowRightIcon} alt="Volgende" onClick={handleNext} />
          </div>
        </>
      )}
    </>
  );
};

export default EventOpenData;
